import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

const ValidationConfirmationModal = ({
  isVisible,
  validationMessage,
  onCancel,
  onProceed,
}) => (
  <Modal
    title="Validation Warning"
    closeAction={onCancel}
    dismissText="Cancel"
    dismissAction={onCancel}
    submitText="Proceed"
    submitAction={onProceed}
    isVisible={isVisible}
    size="md"
  >
    <div className="validation-confirmation-modal">
      <div className="alert alert-warning" role="alert">
        <strong>Validation Issue:</strong>
      </div>
      <p className="mb-3">{validationMessage}</p>
      <p className="text-muted">
        <small>
          You can proceed with the current selection, but please verify that this is what you intended.
          To correct the selection, click &quot;Cancel&quot; and adjust your period selections.
        </small>
      </p>
    </div>
  </Modal>
);

ValidationConfirmationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  validationMessage: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

ValidationConfirmationModal.defaultProps = {
  validationMessage: 'A validation issue was detected with your current selection.',
};

export default ValidationConfirmationModal;
